import axios from 'axios';

const idsecureAPI = process.env.REACT_APP_IDSECURE_API_URL;

export function getAllPersons(params: any) {
  return axios.get(`${idsecureAPI}/permissionReports/persons`, {params});
}

export function getAllAreas(params: any) {
  return axios.get(`${idsecureAPI}/permissionReports/areas`, {params});
}

export function getAllDevices(params: any) {
  return axios.get(`${idsecureAPI}/accesslog/devices`, {params});
}

export function findGroups(queryParams: any) {
  return axios.get(`${idsecureAPI}/permissionReports/groups`, {
    params: queryParams
  });
}

export function getAllAccessRules(params: any) {
  return axios.get(`${idsecureAPI}/permissionReports/accessrule`, {params});
}

export type GetProps = {
  pageSize: number;
  sortField: string;
  pageNumber: number;
  sortOrder: string;
  AreaIds?: string;
  Ids?: string;
};

export function getLogsToPerson(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/person`, {
    params: {
      ...props
    }
  });
}

export function getLogsToGroupsPerson(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/group`, {
    params: {
      ...props
    }
  });
}

export function getLogsToCompanies(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/company`, {
    params: {
      ...props
    }
  });
}

export function getLogsToGroupVisitors(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/visitor`, {
    params: {
      ...props
    }
  });
}

export function getLogsToGroupPersonsArea(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/personArea`, {
    params: {
      ...props
    }
  });
}

export function getLogsToGroupArea(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/personArea`, {
    params: {
      ...props
    }
  });
}

export function getLogsToGroupAreas(props: GetProps) {
  return axios.get(`${idsecureAPI}/permissionReports/groupArea`, {
    params: {
      ...props
    }
  });
}
